export const config = {
  title: "ALVAREZ CLEANING LLC | Cleaning Services in New Castle County, Delaware",
  meta: {
    description:
      "ALVAREZ CLEANING LLC provides professional residential and commercial cleaning services across New Castle County, Delaware. We deliver spotless, reliable, and affordable cleaning solutions.",
    keywords: [
      "Alvarez Cleaning LLC",
      "Cleaning Services Delaware",
      "House Cleaning New Castle County",
      "Office Cleaning Delaware",
      "Residential Cleaning",
      "Commercial Cleaning"
    ],
    author: "ALVAREZ CLEANING LLC",
    canonicalUrl: "https://alvarezcleaningllc.com/",
  },
  sections: {
    header: {
      businessName: "ALVAREZ CLEANING LLC",
    },
    sectionB: {
      heroTitle: "Professional Cleaning You Can Trust",
      heroSubtitle: "Residential & Commercial Cleaning in New Castle County, Delaware",
      learnAboutText: "Get a Free Quote",
      phoneNumber: "3024079777",
      phoneLabel: "(302) 407-9777",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1417833126/photo/close-up-on-a-professional-cleaner-cleaning-a-table-at-a-house.jpg?s=612x612&w=0&k=20&c=W1U2AymCAfC98MZfo5Q7e7xuP3u3Q92PyHsYajBlHiY=",
      cardData: [
        {
          title: "Residential Cleaning",
          description:
            "Keep your home sparkling clean with our reliable and affordable residential cleaning services.",
        },
        {
          title: "Commercial Cleaning",
          description:
            "Maintain a professional environment with our office and commercial cleaning solutions.",
        },
        {
          title: "Customized Service",
          description:
            "We tailor our cleaning services to fit your unique schedule and needs.",
        },
      ],
      description:
        "ALVAREZ CLEANING LLC proudly serves New Castle County, DE, with expert cleaning services for homes, offices, and businesses.",
    },
    sectionC: {
      servicesTitle: "Our Cleaning Services",
      servicesDescription:
        "From small apartments to large offices, our team provides thorough and dependable cleaning services.",
      cards: [
        {
          title: "House Cleaning",
          description:
            "Deep cleaning, regular maintenance, and move-in/move-out services.",
          imageSrc: "https://media.istockphoto.com/id/2225923060/photo/cleaning-lady-is-cleaning-a-wooden-table-with-a-blue-rag-and-detergent-spray.jpg?s=612x612&w=0&k=20&c=cskxk_Yi9Ua7Kib5nz_2g4O7KSZiC6VMiNfinhJXBM8=",
          imageAlt: "House Cleaning",
        },
        {
          title: "Office & Commercial Cleaning",
          description:
            "Professional cleaning for offices, retail, and commercial spaces.",
          imageSrc: "https://media.istockphoto.com/id/2159632844/photo/commercial-office-cleaners.jpg?s=612x612&w=0&k=20&c=1cgFp-uxCXLAXY9yAB_hQNZqq6hcTZ0bVG77D7njKVY=",
          imageAlt: "Commercial Cleaning",
        },
        {
          title: "Specialized Services",
          description:
            "Floor care, kitchen cleaning, bathroom sanitization, and more.",
          imageSrc: "https://media.istockphoto.com/id/1417833187/photo/professional-cleaner-vacuuming-a-carpet.jpg?s=612x612&w=0&k=20&c=5h8NBR190d46Ni4MclqJ7Zf9ZOtf3TM3gPRJaHUdMjk=",
          imageAlt: "Specialized Cleaning",
        },
      ],
      otherServicesTitle: "Other Services",
      otherServicesList: [
        "Deep Cleaning",
        "Move-In / Move-Out Cleaning",
        "Recurring Cleaning Plans",
        "Eco-Friendly Cleaning",
      ],
    },
    sectionD: {
      aboutTitle: "About ALVAREZ CLEANING LLC",
      aboutImage: {
        src: "https://lirp.cdn-website.com/a83ac74f/dms3rep/multi/opt/cleaning9-608h.jpg",
        alt: "Alvarez Cleaning Team",
      },
      aboutText: [
        "At ALVAREZ CLEANING LLC, we believe a clean space is a healthy space. With years of experience, we provide reliable cleaning solutions tailored to both residential and commercial clients.",
        "Our mission is to deliver quality service, exceptional customer care, and spotless results every time.",
      ],
    },
    sectionE: {
      profileImage: "https://lirp.cdn-website.com/a83ac74f/dms3rep/multi/opt/aclogo-120w.JPG",
      profileAlt: "ALVAREZ CLEANING LLC Logo",
      businessName: "ALVAREZ CLEANING LLC",
      contact: {
        phone: "3024079777",
        phoneLabel: "(302) 407-9777",
        email: "alvarezcleaning165@gmail.com",
        website: "https://alvarezcleaningllc.com/",
        address: "New Castle County, Delaware, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "New Castle County, Delaware, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d310681.748!2d-75.789!3d39.582!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c7a9a23a0d27d7%3A0xabcdef123456789!2sNew%20Castle%20County%2C%20DE!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;
